export function automataNavigatorFn(e: Event): {
	routeToNavigate: string | null;
} {
	e.preventDefault();
	const path = e.composedPath() as Array<Element>;
	const anchor = path.find((p) => p.localName === "a");
	if (!anchor) {
		return { routeToNavigate: null };
	}
	const routeToNavigate = anchor.getAttribute("href");
	if (routeToNavigate) {
		return { routeToNavigate: routeToNavigate.replace("#", "") };
	}
	return { routeToNavigate: null };
}
